import { render, staticRenderFns } from "./AdminBalanceTransfer.vue?vue&type=template&id=7ad634a2&"
import script from "./AdminBalanceTransfer.vue?vue&type=script&lang=js&"
export * from "./AdminBalanceTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports